import { LOCALES, DEFAULT_LOCALE, type Lang } from './i18n';

const STORAGE_KEY = 'armprogress_lang_checked';

function currentLocaleFromPath(pathname: string): Lang {
  for (const l of LOCALES) {
    if (l === DEFAULT_LOCALE) continue;
    if (pathname === `/${l}` || pathname.startsWith(`/${l}/`)) return l;
  }
  return DEFAULT_LOCALE;
}

export function matchBrowserLocale(): Lang | null {
  const prefs = (navigator.languages?.length ? navigator.languages : [navigator.language]).map((l) =>
    l.toLowerCase()
  );
  for (const pref of prefs) {
    const exact = LOCALES.find((l) => l.toLowerCase() === pref);
    if (exact) return exact;
    const base = pref.split('-')[0];
    const baseMatch = LOCALES.find((l) => l.toLowerCase().split('-')[0] === base);
    if (baseMatch) return baseMatch;
  }
  return null;
}

// Runs once per browser: if the visitor lands on an unprefixed (English) page
// and their browser language matches a supported locale, redirect them there.
// Falls back to English (no redirect) if unsupported or already checked.
export function initLanguageRedirect() {
  if (typeof window === 'undefined') return;
  // Never redirect inside an iframe (embedded tools), and tolerate blocked storage.
  if (window.self !== window.top) return;
  try {
    if (localStorage.getItem(STORAGE_KEY)) return;
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    return;
  }

  if (currentLocaleFromPath(window.location.pathname) !== DEFAULT_LOCALE) return;

  const preferred = matchBrowserLocale();
  if (!preferred || preferred === DEFAULT_LOCALE) return;

  const suffix = window.location.pathname === '/' ? '' : window.location.pathname;
  window.location.replace(`/${preferred}${suffix}${window.location.search}${window.location.hash}`);
}
